const styles = (theme) => ({
  headerTitle: {
    fontSize: 20,
    fontWeight: 'lighter',
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
  },
  toolbar: {
    boxShadow: '0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.20);',
    background: theme.color.white,
    justifyContent: 'space-evenly',
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.breakpoints.values.sm,
      margin: '0 auto',
    },
  },
  icons: {
    color: theme.color.black,
    flexDirection: 'column',
  },
  customBadge: {
    color: theme.color.white,
  },
  disabled: {
    pointerEvents: 'none',
  },
  iconLabel: {
    display: 'flex',
    flexFlow: 'column',
  },
  semiTransparent: {
    opacity: 0.54,
  },
  offset: theme.mixins.toolbar,
});

export default styles;
